import React from "react";
const HeartIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width="14"
      height="14"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M10.274 0a3.726 3.726 0 0 1 3.047 5.871h.002L7 14 .677 5.871A3.726 3.726 0 1 1 7 1.947 3.724 3.724 0 0 1 10.274 0Z"
          fill="#ED1C24"
        />
        <path
          d="M3.726 1.355c.363 0 .708.082 1.015.228A3.274 3.274 0 0 0 1.583 4.74a2.371 2.371 0 0 1 2.143-3.386Z"
          fill="#FFF"
        />
        <path
          d="M10.274 0a3.726 3.726 0 0 1 3.047 5.871h.002L7 14 .677 5.871.67 5.86l-.012-.02-.005-.013c-.003-.01.001-.013.01-.011l.015.005a.18.18 0 0 1 .01.004l.036.021.05.033.085.062.108.084.168.133.248.204.41.346.571.49.367.317.84.735L4.989 9.5l1.308 1.163.652.581 4.666-6A3.185 3.185 0 0 0 9.08.227h-.085C9.393.08 9.824 0 10.274 0Z"
          fill="#C1272D"
        />
        <path
          d="M10.274.339c.936 0 1.782.379 2.395.992s.992 1.46.992 2.395c0 .723-.226 1.393-.612 1.943L7 13.45.95 5.668a3.382 3.382 0 0 1-.611-1.943c0-.936.379-1.782.992-2.395A3.376 3.376 0 0 1 3.726.339a3.37 3.37 0 0 1 1.728.473A3.405 3.405 0 0 1 7 2.853 3.396 3.396 0 0 1 8.546.812a3.37 3.37 0 0 1 1.728-.473Z"
          stroke="#650408"
          strokeWidth=".677"
        />
      </g>
    </svg>
  )
);
HeartIcon.displayName = "HeartIcon";
export default HeartIcon;
